import { AllocationMethod } from './types'

/**
 * Oletusoffset historiapainotukselle (kuukausia)
 */
export const DEFAULT_HISTORY_OFFSET_MONTHS = 12

/**
 * Allocation method labels and descriptions are now in translation files
 * Use t('allocationMethod:divideEvenly') for labels
 * Use t('allocationMethod:divideEvenlyDescription') for descriptions
 */

/**
 * Oletusjakotapa
 */
export const DEFAULT_ALLOCATION_METHOD = AllocationMethod.DIVIDE_EVENLY
